import { html } from '@design.estate/dees-element';
import { demoPage } from '../../demos/templates.js';

export const demoFunc = () => demoPage('Overflow text', 'Readable activity labels that reveal their full content when needed.', html`
  <style>
    .overflowTextDemo {
      display: grid;
      gap: 16px;
      max-width: 360px;
    }
    .overflowTextDemo .label {
      color: var(--dees-color-text-muted);
      font-size: 11px;
      font-weight: 500;
    }
  </style>
  <div class="overflowTextDemo">
    <div class="label">short text</div>
    <dees-harness-overflow-text>
      Fits without a fade
    </dees-harness-overflow-text>
    <div class="label">overflowing text</div>
    <dees-harness-overflow-text>
      This long activity description reveals its hidden ending after the initial delay or on hover
    </dees-harness-overflow-text>
  </div>
`);
